/**
 * Playready HTTP Headers.
 *
 * @group DRM
 *
 * @beta
 */
export const HTTP_HEADERS = 'HttpHeaders';
//# sourceMappingURL=HTTP_HEADERS.js.map